// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Banner_sliderContainer__XNxbA","banner":"Banner_banner__kzZwD"};